/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import logo from "../assets/images/maxtronlogo.png";
import face from "../assets/images/icons/face.svg";
import insta from "../assets/images/icons/insta.svg";
import tele from "../assets/images/icons/tele.svg";

const Footer = () => {
  return (
    <>
      <footer
        className="bg-[#090909] relative h-[380px] hidden md:block"
        style={{ clipPath: "polygon(0% 0, 100% 0%, 100% 100%, 0 100%)" }}
      >
        <div className="flex fixed bottom-0 h-[380px] w-full ">
          <div className="flex justify-center mx-auto items-center md:items-start my-auto">
            <div className="flex flex-col items-center">
              <img
                src={logo}
                alt="Samurai Logo"
                className="w-[100px] h-[100px] mb-4"
              />
              {/* <p className="text-xl text-gray-400">SAMURAI</p> */}
            </div>
          </div>

          <div className="border-dashed border-l-2 border-r-2 border-[#F7C97A] p-20">
            <div className="grid grid-cols-3 gap-x-40 gap-y-20 text-center ">
              <a href="#" className="hover:text-gray-300">
                Careers
              </a>
              <a href="#" className="hover:text-gray-300">
                Case Studies
              </a>
              <a href="#" className="hover:text-gray-300">
                Services
              </a>
              <a href="#" className="hover:text-gray-300">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-gray-300">
                About
              </a>
              <a href="#" className="hover:text-gray-300">
                Industries
              </a>
            </div>

            <div className="mt-10 flex justify-center items-center  pt-6">
              <div className="mr-10">Connect</div>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-white">
                  <img src={face} alt="insta" />
                </a>
                <a href="#" className="text-gray-400 hover:text-white">
                  <img src={insta} alt="insta" />
                </a>
                <a href="#" className="text-gray-400 hover:text-white">
                  <img src={tele} alt="tele" />
                </a>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center mx-auto my-auto">
            <p className=" text-center">
              Protect your assets. <br />
              Get a security assessment.
            </p>
            <button className="mt-10 px-[25px] py-5 border border-[#EAE2C3] text-[#EAE2C3] bg-[#111111] rounded-full hover:bg-gray-800">
              CONTACT US
            </button>
          </div>
        </div>
      </footer>

      <footer
        className="bg-[#090909] relative block md:hidden"
        style={{ clipPath: "polygon(0% 0, 100% 0%, 100% 100%, 0 100%)" }}
      >
        <div className="flex flex-col md:flex-row md:h-[380px] md:justify-between">
          <div className="flex flex-col items-center md:items-start py-10 md:py-0">
            <img
              src={logo}
              alt="Samurai Logo"
              className="w-[76px] h-[76px] mb-4"
            />
            <p className="text-xl text-gray-400">Maxtron Strategy</p>
          </div>

          <div className="border-dashed border-t-2 md:border-t-0 md:border-l-2 md:border-r-2 border-[#F7C97A] px-6 md:px-20 py-10 md:py-0 flex-grow">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-8 gap-y-6 text-center">
              <a href="#" className="hover:text-gray-300">
                Careers
              </a>
              <a href="#" className="hover:text-gray-300">
                Case Studies
              </a>
              <a href="#" className="hover:text-gray-300">
                Services
              </a>
              <a href="#" className="hover:text-gray-300">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-gray-300">
                About
              </a>
              <a href="#" className="hover:text-gray-300">
                Industries
              </a>
            </div>

            <div className="mt-10 flex flex-col items-center space-y-4">
              <span className="text-gray-400">Connect</span>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-white">
                  <img src={face} alt="Facebook" />
                </a>
                <a href="#" className="text-gray-400 hover:text-white">
                  <img src={insta} alt="Instagram" />
                </a>
                <a href="#" className="text-gray-400 hover:text-white">
                  <img src={tele} alt="Telegram" />
                </a>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center md:items-start py-10 md:py-0 text-center md:text-left">
            <p className="text-gray-400">
              Protect your assets. <br />
              Get a security assessment.
            </p>
            <button className="mt-6 px-[25px] py-3 border border-[#EAE2C3] text-[#EAE2C3] bg-[#111111] rounded-full hover:bg-gray-800">
              CONTACT US
            </button>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
